import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
  LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  REQUEST_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/verify-otp`,
  PRIMARY_CREATE_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/primary-create-onboarding`,

  TOTAL_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/total-counts`,
  PARENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/parent-list`,
  UPLOAD_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/upload-document`,

  KYC_FORM_FIELDS_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/insert-kyc`,
  GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/get-entities`,
  UPDATE_FORM_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/update-entity`,

  APPROVE_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/approve-entity`,
  APPROVE_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/approve-document`,
  DEFICIENCY_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/deficiency-entity`,
  VIEW_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/view-document`,
  COMPANY_CHILD_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-parent-child`,

  ENTITY_KYC_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-kyc-status`,
  RESEND_KYC_LINK: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/resend-kyc-link`,
  UPLOAD_EXCEL: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/upload-ledger`,
  SAVE_ENTITY_LEDGER: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/save-entity-ledger`,
  ENTITY_LEDGER_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-ledger-status`,
  DOWNLOAD_UPLOADED_FILE_LAGDER: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/download-excel`,
  DOWNLOAD_LEDGER: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/download-ledger`,
  GET_AUDIT_LOGS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/get-audit-logs`,
  ENTITY_ACTIVE_INACTIVE: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-active-inactive`,
  TAT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/tat-list`,
  UPDATE_ENCRYPTED_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/update-encrypted-data`,
  DELETE_ENTITY: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/delete-entity`,
  DOWNLOAD_TEMPLATE: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/download-template`,
  VALIDATE_LEDGER_TEMPLATE: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/validate-ledger-template`,
  SET_LEDGER_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/set-ledger-status`,
  INSERT_LEDGER_DETAILS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/insert-ledger-details`,
  UPDATE_INDIVIDUAL_LEDGER: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/update-individual-ledger`,
  BULK_UPLOAD_ONBOARDING: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/upload-bulk-onboarding`,
  BULK_ONBOARDING_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/bulk-onboarding-list`,
  UPLOAD_ONBOARDING_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/bulk-upload-onboarding-documents-new`,
  ONBOARDING_DOCUMENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/onboarding-document-list`,
  VIEW_ONBOARDING_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/view-onboarding-document`,
  DASHBOARD_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/dashboard-counts`,
  SPOC_CREATE: `${URL_CONFIG.ATP_API_BASE_URL}api/SpocCreation/create-spoc`,
  SPOC_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/SpocCreation/spoc-list`,
  SPOC_UPDATE: `${URL_CONFIG.ATP_API_BASE_URL}api/SpocCreation/update-spoc`,
  SPOC_ACTIVE_INACTIVE: `${URL_CONFIG.ATP_API_BASE_URL}api/SpocCreation/active-inactive-spoc`,

  // new apis here
  BULK_SEARCH_ALL_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/bulk-search-entities`,
  SEND_DOWNLOAD_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/send-download-otp`,
  VERIFY_DOWNLOAD_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/verify-download-otp`,
  RESEND_DOWNLOAD_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/resend-download-otp`,
  DOWNLOAD_ENTITY_EXCEL: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/download-entity-excel`,
  BULK_UPLOAD_ONBOARDING_EXCELSHETT_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/bulk-upload-onboarding-excel-new`,
  VIEW_BULK_UPLOAD_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/view-bulk-upload-onboarding-document-new`,
  BULK_UPLOAD_DOCUMENT_VIEW_ALL: `${URL_CONFIG.ATP_API_BASE_URL}api/BulkUpload/get-bulk-upload-onboarding-documents-new`,
};
